export type Language = 'ru' | 'en';

export const translations: Record<Language, Record<string, string>> = {
  ru: {
    // Instructions
    instruction1: '1. Скопируйте номер счёта и откройте банковское приложение',
    instruction2: '2. Отправьте ровно {amount} KZT одним платежом',
    instruction3: '3. Вернитесь сюда и подтвердите перевод',

    // Transfer details
    copyTransferDetails: 'Скопировать реквизиты перевода',
    bankName: 'Банк',
    cardNumber: 'Карта получателя',
    phoneNumber: 'Номер телефона',
    accountHolder: 'Владелец счёта',

    // Status
    waitingForTransfer: 'Мы ждём ваш перевод:',
    minutesShort: 'м',
    secondsShort: 'с',

    // Button
    sentMoney: 'Я отправил деньги',
    processing: 'Обработка...',
    timeExpired: 'Время истекло',
    paymentConfirmed: 'Платёж подтверждён',
    cancelPayment: 'Отменить (я не совершал оплату)',

    // Hint
    sendExactAmount: 'Отправьте точную сумму одним платежом, чтобы избежать задержек в обработке',

    // Copy
    copy: 'Копировать',
    successfullyCopied: 'Успешно скопировано!',

    // States
    loading: 'Загрузка данных платежа...',
    preparingPayment: 'Подготовка платёжных данных',
    pleaseWait: 'Пожалуйста, подождите.',
    paymentNotFound: 'ID платежа не найден',
    dataNotFound: 'Данные платежа не найдены',

    // Confirm dialogs
    success: 'Платёж подтверждён',
    successDescription: 'Ваш перевод успешно получен и подтверждён.',
    successReturnHint: 'Теперь вы можете вернуться на сайт.',
    expired: 'Сессия оплаты истекла',
    expiredDescription: 'Время оплаты закончилось, и этот запрос на перевод больше не активен.',
    expiredHint: 'Пожалуйста, создайте новый запрос на оплату, чтобы продолжить.',
    expiredTryAgain: 'Попробуйте снова',

    // Failed page
    failedTitle: 'Платеж не подтвержден',
    failedDescription: 'Мы не смогли подтвердить ваш перевод в ожидаемое время.',
    failedHint: 'Если деньги были отправлены, они могут быть обработаны позже или возвращены вашим провайдером.',
    tryAgain: 'Попробуйте снова',
    contactSupport: 'Связаться с поддержкой',
    processingPayment: 'Обработка платежа!',
    processingDescription: 'Свяжитесь с поддержкой, если ваша транзакция не обработана в течение нескольких минут.',
    backToSite: 'Вернуться на сайт',

    // Pending page
    pendingTitle: 'Платёж проверяется',
    pendingDescription: 'Мы получили ваше подтверждение и ждём, пока платёжный провайдер подтвердит перевод. Обычно это занимает несколько минут.',
    pendingKeepOpen: 'Пожалуйста, оставьте эту страницу открытой.',
    refreshStatus: 'Обновить статус',
    backToMerchant: 'Вернуться на сайт',

    // Receipt upload
    receiptUploadHint: 'Для ускорения обработки - загрузите квитанцию об оплате',
    uploadReceipt: 'Загрузить квитанцию',
    receiptFormats: 'JPG, PNG, WebP или PDF, максимум 5 МБ',
    receiptUploading: 'Загрузка...',
    receiptUploaded: 'Квитанция загружена',
    receiptUploadError: 'Ошибка загрузки',
    receiptFileTooLarge: 'Файл слишком большой (максимум 5 МБ)',
    receiptInvalidFormat: 'Неверный формат файла',
    receiptRateLimited: 'Подождите перед повторной загрузкой',

    // Unavailable page
    unavailableTitle: 'Платёж недоступен',
    unavailableDescription: 'Не удалось создать платёжные данные в данный момент.',
  },
  en: {
    // Instructions
    instruction1: '1. Copy the account number and open your banking app',
    instruction2: '2. Send exactly {amount} KZT in one payment',
    instruction3: '3. Return here and confirm the transfer',

    // Transfer details
    copyTransferDetails: 'Copy transfer details',
    bankName: 'Bank',
    cardNumber: 'Recipient card',
    phoneNumber: 'Phone number',
    accountHolder: 'Account holder',

    // Status
    waitingForTransfer: "We're waiting for your transfer:",
    minutesShort: 'm',
    secondsShort: 's',

    // Button
    sentMoney: "I've sent the money",
    processing: 'Processing...',
    timeExpired: 'Time expired',
    paymentConfirmed: 'Payment confirmed',
    cancelPayment: 'Cancel (I did not make the payment)',

    // Hint
    sendExactAmount: 'Send the exact amount in one payment to avoid delays in processing',

    // Copy
    copy: 'Copy',
    successfullyCopied: 'Successfully copied!',

    // States
    loading: 'Loading payment data...',
    preparingPayment: 'Preparing payment details',
    pleaseWait: 'Please wait a moment.',
    paymentNotFound: 'Payment ID not found',
    dataNotFound: 'Payment data not found',

    // Confirm dialogs
    success: 'Payment confirmed',
    successDescription: 'Your transfer has been successfully received and verified.',
    successReturnHint: 'You can now return to the site.',
    expired: 'Payment session expired',
    expiredDescription: 'The payment time has ended and this transfer request is no longer active.',
    expiredHint: 'Please create a new payment request to continue.',
    expiredTryAgain: 'Try again',

    // Failed page
    failedTitle: 'Payment not confirmed',
    failedDescription: "We couldn't verify your transfer within the expected time.",
    failedHint: 'If money was sent, it may still be processed later or returned by your provider.',
    tryAgain: 'Try again',
    contactSupport: 'Contact support',
    processingPayment: 'Processing payment!',
    processingDescription: 'Contact Customer Support if your transaction is not processed within a few minutes.',
    backToSite: 'Back to site',

    // Pending page
    pendingTitle: 'Payment is being verified',
    pendingDescription: "We received your confirmation and are waiting for the payment provider to verify the transfer. This usually takes a few minutes.",
    pendingKeepOpen: 'Please keep this page open.',
    refreshStatus: 'Refresh status',
    backToMerchant: 'Back to site',

    // Receipt upload
    receiptUploadHint: 'To speed up processing - upload a payment receipt',
    uploadReceipt: 'Upload receipt',
    receiptFormats: 'JPG, PNG, WebP or PDF, maximum 5 MB',
    receiptUploading: 'Uploading...',
    receiptUploaded: 'Receipt uploaded',
    receiptUploadError: 'Upload failed',
    receiptFileTooLarge: 'File too large (maximum 5 MB)',
    receiptInvalidFormat: 'Invalid file format',
    receiptRateLimited: 'Please wait before uploading again',

    // Unavailable page
    unavailableTitle: 'Payment unavailable',
    unavailableDescription: "We couldn't create payment details right now.",
  },
};

export type TranslationKey = keyof typeof translations.ru;

export const getLanguageFromUrl = (): Language => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');

  if (lang === 'en') return 'en';
  return 'ru';
};

export const t = (key: string, params?: Record<string, string | number>): string => {
  const lang = getLanguageFromUrl();
  let text = translations[lang][key] || translations.ru[key] || key;

  if (params) {
    Object.entries(params).forEach(([paramKey, value]) => {
      text = text.replace(`{${paramKey}}`, String(value));
    });
  }

  return text;
};

export const useTranslation = () => {
  const lang = getLanguageFromUrl();

  const translate = (key: string, params?: Record<string, string | number>): string => {
    let text = translations[lang][key] || translations.ru[key] || key;

    if (params) {
      Object.entries(params).forEach(([paramKey, value]) => {
        text = text.replace(`{${paramKey}}`, String(value));
      });
    }

    return text;
  };

  return { t: translate, lang };
};
